import React from "react";
import { useState } from "react";

import format_date_formal from "../../App/validation/format_date_formal";
import Modal from "../common_modal/Modal";
import { TABLE_NESTED_CELL } from "../custom_cell";

const POPUP_SMALL = ({
  geo_layer_id,
  feature,
  fields,
  type_2,
  onClose,
  handleFullScreen,
  onBanjirGenerate,
}) => {
  const { properties } = feature || {};

  const [state, setState] = useState({
    modal_desc: false,
    value_state: "",
  });

  const { modal_desc, value_state } = state;

  const toggle_desc = (value_state) => {
    setState((prevState) => ({
      ...prevState,
      modal_desc: !prevState.modal_desc,
      value_state: value_state,
    }));
  };

  // Filter out style fields
  const filteredFields = fields.filter(
    (field) => !!field?.isStyle === false && !field?.parent_uuid
  );

  const renderFieldValue = (field, value) => {
    switch (field.type) {
      case "text":
        return <div className="text_bold">{value || "-"}</div>;

      case "number":
        const formattedNumber = !isNaN(value)
          ? new Intl.NumberFormat("id-ID", { style: "decimal" }).format(value)
          : value;
        return <div className="text_bold">{formattedNumber || "-"}</div>;

      case "currency":
        const formattedCurrency = !isNaN(value)
          ? new Intl.NumberFormat("id-ID", { style: "decimal" }).format(value)
          : value;
        return <div className="text_bold">{formattedCurrency || "-"}</div>;

      case "date":
        const formattedDate = format_date_formal(value);
        return <div className="text_bold">{formattedDate || "-"}</div>;

      case "last_edited":
        let fmtdDate = "-";
        if (value) {
          const date = new Date(value);

          // --- FIX START: Check validity before formatting ---
          if (!isNaN(date.getTime())) {
            try {
              let formatter = new Intl.DateTimeFormat("id-ID", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
                timeZone: "Asia/Jakarta",
              });
              fmtdDate = formatter.format(date);
            } catch (error) {
              console.error("Error formatting date:", error);
              fmtdDate = "-";
            }
          }
          // --- FIX END ---
        }

        return <div className="text_bold">{fmtdDate}</div>;

      case "image":
        return (
          <div>
            <img
              src={value}
              alt={field.name || "Image"}
              className="photo_popup"
            />
          </div>
        );

      case "document":
        return (
          <>
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              className="button_small button_white outline_black text_left"
            >
              Download doc
            </a>
            <br />
          </>
        );

      case "link":
        const href =
          !value?.includes("https://") && !value?.includes("http://")
            ? `https://${value}`
            : value;
        return (
          <>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="button_small button_white outline_black text_left"
            >
              View link to {value}
            </a>
            <br />
          </>
        );

      case "textarea":
        return (
          <>
            <div
              style={{
                maxHeight: "100px",
                overflowY: "hidden",
                border: "1px solid #ccc",
                padding: "8px",
                whiteSpace: "pre-wrap",
              }}
            >
              {value || "-"}
            </div>
            <button
              className="button_small button_white outline_black text_left"
              onClick={() => {
                toggle_desc(value);
              }}
            >
              Perbesar
            </button>
            <br />
          </>
        );
      case "table":
        // console.log("feature", feature);
        // console.log("geo_layer_id", geo_layer_id);
        // console.log("field", field);
        return (
          // <></>
          <TABLE_NESTED_CELL
            layer_id={geo_layer_id}
            row={feature}
            column={field}
            is_from_first_gen_table={true}
          />
        );
      default:
        return <div className="text_bold">{value || "-"}</div>;
    }
  };

  //content
  const modal_desc_content = modal_desc && (
    <Modal modalSize="small" isOpen={modal_desc} onClose={() => toggle_desc()}>
      <div className="box-body" id="box-body">
        <div className="container background_white outline_black margin_bottom_extra text_medium sub_color">
          {value_state}
        </div>
        <button
          className="button_big button_white outline_shadow_soft"
          onClick={() => toggle_desc()}
        >
          Tutup
        </button>
      </div>
    </Modal>
  );

  return (
    <main id={`popup_${properties?.key}`}>
      {modal_desc_content}
      {/* Header with buttons */}
      <div
        style={{
          position: "sticky",
          top: "0",
          background: "white",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0",
        }}
      >
        <button
          className="button button_white outline_black text_left"
          onClick={() => handleFullScreen()}
        >
          Perbesar
        </button>
        <button className="button_circle_2 background_black" onClick={onClose}>
          X
        </button>
      </div>

      {/* Scrollable content section */}
      <section
        style={{
          width: "200px",
          maxWidth: "80vw",
          maxHeight: "200px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* Banjir button */}
        {type_2 === "banjir" && (
          <button
            className="button button_white outline_black text_left marginTop_10"
            onClick={onBanjirGenerate}
          >
            Generate Genangan
          </button>
        )}

        {/* Dynamic field content */}
        {filteredFields.map((field, index) => {
          const value = properties?.[field?.key];

          return (
            <React.Fragment key={field?.key || index}>
              <div className="text_small">{field?.name}</div>
              <br />
              {renderFieldValue(field, value)}
              <br />
            </React.Fragment>
          );
        })}
      </section>
    </main>
  );
};

export default POPUP_SMALL;
